import { c as _c } from "react/compiler-runtime";
import './review.scss';
import { t } from 'i18next';
import { Divider } from '@sola/ark-core/atoms/divider/divider.tsx';
import { Prominence, Purposes, Sizes, Text, Variants } from '@sola/ark-core/atoms/text/text.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
export type ReviewProps = {
  name?: string;
  sponsorDuration?: string;
  location?: string;
  rating?: number;
  reviewTitle?: string;
  review?: string;
  recommendsCompassion?: boolean;
};
export const Review: React.FC<ReviewProps> = t0 => {
  const $ = _c(40);
  const {
    name,
    sponsorDuration,
    location,
    rating,
    reviewTitle,
    review,
    recommendsCompassion
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== location || $[1] !== name || $[2] !== sponsorDuration) {
    let time;
    bb0: switch (sponsorDuration) {
      case "25 Years or More":
        {
          time = t("skippy:reviews.sponsor", {
            context: "twentyFiveYear"
          });
          break bb0;
        }
      case "10 to 25 Years":
        {
          t("skippy:reviews.sponsor", {
            context: "tenYear"
          });
        }
      case "1 to 10 Years":
        {
          time = t("skippy:reviews.sponsor", {
            context: "oneYear"
          });
          break bb0;
        }
      case "New Sponsor":
        {
          time = t("skippy:reviews.sponsor", {
            context: "new"
          });
          break bb0;
        }
      default:
        {
          time = t("skippy:reviews.sponsor", {
            context: "na"
          });
        }
    }
    const where = location && location !== "" ? t("skippy:reviews.from", {
      place: location
    }) : "";
    t6 = "Review flex flex-col";
    if ($[11] !== name) {
      t7 = <Text prominence={"potent" as Prominence} size={"xl" as Sizes} variant={"label" as Variants}>{name}</Text>;
      $[11] = name;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    T0 = Text;
    t1 = "neutral" as Purposes;
    t2 = "moderate" as Prominence;
    t3 = "lg" as Sizes;
    t4 = "label" as Variants;
    t5 = t("skippy:reviews.description", {
      time,
      where
    });
    $[0] = location;
    $[1] = name;
    $[2] = sponsorDuration;
    $[3] = T0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    T0 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[13] !== T0 || $[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t8 = <T0 purpose={t1} prominence={t2} size={t3} variant={t4}>{t5}</T0>;
    $[13] = T0;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Divider purpose="neutral" className="my-comfy-md" />;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [1, 2, 3, 4, 5];
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== rating) {
    t11 = <div className="flex-row mb-comfy-md">{t10.map(element => rating && rating < element ? <ArkIcon iconName="star-01" key={element} className="Review__star--grey" /> : <ArkIcon iconName="star-01" key={element} className="Review__star--gold" />)}</div>;
    $[22] = rating;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== reviewTitle) {
    t12 = <Text prominence={"potent" as Prominence} size={"xl" as Sizes} variant={"label" as Variants}>{reviewTitle}</Text>;
    $[24] = reviewTitle;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== review) {
    t13 = <Text size={"sm" as Sizes} variant={"body" as Variants} purpose={"neutral" as Purposes} prominence={"mild" as Prominence}>{review}</Text>;
    $[26] = review;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13) {
    t14 = <div className="flex flex-col gap-comfy-xs">{t12}{t13}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== recommendsCompassion) {
    t15 = recommendsCompassion && <div className="flex flex-row gap-snug-md pt-comfy-xl items-center"><ArkIcon iconName="check-circle" className="Review__check" /><Text size={"lg" as Sizes} prominence={"mild" as Prominence} variant={"label" as Variants} purpose={"neutral" as Purposes}>{t("skippy:reviews.recommend")}</Text></div>;
    $[31] = recommendsCompassion;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t11 || $[34] !== t14 || $[35] !== t15 || $[36] !== t6 || $[37] !== t7 || $[38] !== t8) {
    t16 = <div className={t6}>{t7}{t8}{t9}{t11}{t14}{t15}</div>;
    $[33] = t11;
    $[34] = t14;
    $[35] = t15;
    $[36] = t6;
    $[37] = t7;
    $[38] = t8;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  return t16;
};